import {
  Combobox,
  DropdownButton,
  Icons,
  NoOptionsPlaceholder
} from '@eggplant/pattern-library'
import { GetAiScenariosRequest } from '@eggplant/api-requests'
import { HiOutlineSearch } from 'react-icons/hi'
import type {
  ButtonShape,
  DropdownPlacement,
  Options,
  Placement
} from '@eggplant/types'

interface Props {
  isFilter?: boolean
  isFilterFixedMinMaxWidth?: boolean
  onChange: (value: string) => void
  placeholder?: string
  value?: string
  isDisabled?: boolean
  placement?: Placement
  dropdownPlacement?: DropdownPlacement
}

const getOptions = (items: string[]) =>
  items.map(item => ({
    label: item,
    value: item
  }))

const dropDownIcon = () => <Icons.Scenario size='20' />

const SelectScenario = ({
  isFilter = false,
  isFilterFixedMinMaxWidth = true,
  onChange,
  placeholder = 'Scenario',
  value,
  isDisabled = false,
  placement = undefined,
  dropdownPlacement = 'bottom'
}: Props) => {
  const renderButton = (options: Options) => {
    const currentOption = options.find(item => item.value === value)

    const label = currentOption !== undefined
      ? currentOption.label
      : placeholder

    const tooltip = currentOption !== undefined
      ? `Scenario: ${currentOption.label}`
      : label

    const buttonText = currentOption !== undefined
      ? currentOption.label
      : placeholder

    return (buttonProps: ButtonShape) =>
      <DropdownButton
        {...buttonProps}
        Icon={dropDownIcon}
        dropdownPlacement={dropdownPlacement}
        isDisabled={isDisabled}
        isFilter={isFilter}
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        isHighlighted={!!value}
        label={label}
        placement={placement}
        title={tooltip}
      >
        {buttonText}
      </DropdownButton>
  }

  const noDataPlaceholder =
    <NoOptionsPlaceholder
      icon={
        <HiOutlineSearch
          aria-hidden
          size='24px'
        />
      }
      title='No scenarios found.'
    />

  const renderComboBox = (data: string[]) =>
    <div>
      <Combobox
        dropdownPlacement={dropdownPlacement}
        isDisabled={isDisabled}
        isFilter={isFilter}
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        noOptionsPlaceholder={noDataPlaceholder}
        onChange={onChange}
        options={getOptions(data)}
        placement={placement}
        renderButton={renderButton(getOptions(data))}
        value={value}
      />
    </div>

  return (
    <GetAiScenariosRequest shortErrorMessage='Failed to load scenarios'>
      {
        (items: string[]) =>
          renderComboBox(items)
      }
    </GetAiScenariosRequest>
  )
}

export default SelectScenario
